import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer has seen an Eco-friendly category page *
 */
export const HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE =
  'HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE' as IUserMilestone.RetailerMilestone;
